<script setup lang="ts">
import AnewsHomeNext from '@/components/home/anews-home-next.vue';
import AnewsHome from '@/components/home/anews-home.vue';
import { useIsNextLayout } from '@/utils/composables/useLayoutVariant';

const isNextLayout = useIsNextLayout();
</script>

<template>
  <AnewsHomeNext v-if="isNextLayout" />
  <AnewsHome v-else />
</template>
